<template>
  <Teleport to="body">
    <div class="toast-container position-fixed top-0 end-0 m-3" v-if="notifications.length > 0">
      <div @mouseover="notificationsStore.stopNotificationTimeout(notification)" @mouseleave="notificationsStore.startNotificationTimeout(notification)"
        v-for="notification in notificationsArr" :key="notification.message"
        class="toast show fade"
        :class="{
          'bg-success-subtle border-success': notification.type === 'success',
          'bg-danger-subtle border-danger': notification.type === 'error',
          'bg-primary-subtle border-primary': notification.type === 'info'
        }"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="toast-body d-flex">
          <i
          class="fa-solid me-2 align-top pt-1"
          :class="notification.type === 'success' ? 'fa-circle-check text-success' : notification.type === 'error' ? 'fa-triangle-exclamation text-danger' : 'fa-info-circle text-primary'"
          ></i>
          <div class="d-flex flex-column">
            <div v-html="notification.message"></div>
            <small v-if="notification.details" v-html="notification.details"></small>
          </div>
          <button type="button" class="btn-close ms-auto" @click.prevent="notificationsStore.removeNotification(notification)" aria-label="Close"></button>
        </div>
      </div>
    </div>
  </Teleport>
  <BOrchestrator />
  <LoginView v-if="!userStore.isLoggedIn" />
  <RouterView v-else />
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useUserStore } from '@/stores/userStore'
import { useNotificationsStore } from '@/stores/notificationStore'
import LoginView from '@/views/LoginView.vue'
import { onMounted,computed } from 'vue'
import { storeToRefs } from 'pinia'
import userApi from '@/api/userApi'
import { BOrchestrator } from 'bootstrap-vue-next'

const userStore = useUserStore()
const notificationsStore = useNotificationsStore()

const { notifications } = storeToRefs(notificationsStore)

const notificationsArr = computed(() => [...notifications.value].reverse())

onMounted(() => {
  if (!userStore.isLoggedIn) {
    userApi.getMe().then((response) => {
      if (response.status === 200) {
        userStore.setConnectedUser(response.data)
      }
    }).catch(() => {
      // ignored
    })
  }


  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js')
    })
  }
})
</script>
